<div class="multiple-date-picker">
  <div class="picker-top-row" [ngSwitch]="arrow">
    <div class="text-center picker-navigate picker-navigate-left-arrow" id="button" [ngClass]="{'disabled': disableBackButton}" (click)="changeMonth($event, disableBackButton, -1)">
      <p *ngSwitchDefault>&lt;</p>
      <p *ngSwitchCase="1"><i class="material-icons">keyboard_arrow_left</i></p>
      <p *ngSwitchCase="2"><i class="fa fa-angle-left" aria-hidden="true"></i></p>
    </div>
    <div class="text-center picker-month">
      {{ monthToDisplay }}
      <span *ngIf="yearsForSelect.length < 2">{{ yearToDisplay }}</span>
    </div>
    <div class="text-center picker-navigate picker-navigate-right-arrow" [ngClass]="{'disabled': disableNextButton}" (click)="changeMonth($event, disableNextButton, 1)">
      <p *ngSwitchDefault>&gt;</p>
      <p *ngSwitchCase="1"><i class="material-icons">keyboard_arrow_right</i></p>
      <p *ngSwitchCase="2"><i class="fa fa-angle-right" aria-hidden="true"></i></p>
    </div>
  </div>
  <div class="picker-days-week-row">
    <div class="text-center" *ngFor="let weekDays of daysOfWeek">{{ weekDays }}</div>
  </div>
  <div class="picker-days-row">
    <div dateClicked class="text-center picker-day {{ getDayClasses(day) }}" title="{{ day.title }}" *ngFor="let day of days" (click)="toggleDay($event, day)">
      {{ day ? day.mdp.otherMonth && !showDaysOfSurroundingMonths ? ' ' : day.date.format('D') : '' }}
      <div class="pop-wrap" *ngIf="(day ? day.mdp.otherMonth && !showDaysOfSurroundingMonths ? ' ' : day.date.format('D') : '') != ' ' ">
        $ {{ day.slot.dailyRate }}
      </div>
    </div>
  </div>
</div>
